import CloseIcon from "../ui/icons/CloseIcon";
import SearchIcon from "../ui/icons/SearchIcon";

const ChatMemoSearchBar = ({
  setIsSearchOpen,
  onSearch,
}: {
  setIsSearchOpen: (isOpen: boolean) => void;
  onSearch: (searchText: string) => void;
}) => {
  return (
    <div className="flex justify-between items-center py-4 px-6 border-t border-gray-200">
      <div className="flex gap-1 bg-grey-99 w-[300px] h-[40px] rounded-[8px] border border-grey-90">
        <div className="w-[40px] h-[40px] flex justify-center items-center">
          <SearchIcon color="#333333" />
        </div>
        <input
          type="text"
          placeholder="Keyword"
          className="w-full h-10 rounded-lg bg-grey-99 focus:outline-none"
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <button
        className="flex h-10 w-10 items-center justify-center"
        onClick={() => {
          setIsSearchOpen(false);
          onSearch("");
        }}
      >
        <CloseIcon color="#333333" />
      </button>
    </div>
  );
};

export default ChatMemoSearchBar;
